import { useLocale as mimicLocale } from '@mercadoni/mimic/dist/cjs/locale/contexts/LocaleContext'
import defaultLocale from './defaultLocale'

const getLocale = (ssr?: boolean) => {
  let copies = {}

  // Only call the hook if we're not in SSR mode
  if (!ssr) {
    try {
      copies = mimicLocale()
    } catch (error) {
      console.warn('Failed to get locale from mimicLocale hook:', error)
      copies = defaultLocale
    }
  }

  return copies || defaultLocale
}

export default getLocale
